import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AppUtilityService } from 'src/app/app-utility.service';

import { QuoteStoreService } from '@lmsrestServices';

import { SlidePanelService } from '../slide-panel.service';

@Component({
  selector: 'lms-quote-feed',
  templateUrl: './quote-feed.component.html',
  styleUrls: ['./quote-feed.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('highlightNew', [
      state('default', style({ backgroundColor: 'transparent' })),
      state('recent', style({ backgroundColor: '#ffeaa7' })),
      transition('void => recent', [
        style({ transform: 'scale(0.95)', opacity: 0 }),
        animate('400ms ease-out')
      ]),
      transition('recent => default', animate('1500ms ease-in'))
    ])
  ]
})
export class QuoteFeedComponent {
  @Input() quotes: any[] = []; // Replace with `Quote[]` interface when you finalize typing

  constructor(private quoteStoreService: QuoteStoreService,
    private global_utility: AppUtilityService,
    private panelService: SlidePanelService) {}

  onQuoteClick(quote: any, event: MouseEvent) {
     event.stopPropagation();

      const status = (
        quote?.loanStatus ||
        quote?.status ||
        ''
      ).toString().toLowerCase();

      const isAwaitingAm = status === 'awaitingam';
      const requiresLtApprovalRouting = Boolean(status === 'ltapproval');
      const userJobTitle = this.global_utility.getGlobalData('user_jobtitle')?.toLowerCase() || '';
      const isAreaManager = userJobTitle.includes('area manager');
      const isRegionalManager = userJobTitle.includes('regional manager');

      Promise.resolve().then(() => {
        if (isAwaitingAm) {
          this.loanDetails(quote.quoteId);
        } else if (isAreaManager && requiresLtApprovalRouting) {
          this.global_utility.navigateToURL(['/areamanager/lt-approvals']);
        } else if (isRegionalManager && requiresLtApprovalRouting) {
          this.global_utility.navigateToURL(['/regionalmanager/lt-approvals']);
        } else if (isAreaManager) {
          this.global_utility.navigateToURL(['/areamanager/lt-approvals']);
        } else if (isRegionalManager) {
          this.global_utility.navigateToURL(['/regionalmanager/lt-approvals']);
        } else {
          this.loanDetails(quote.quoteId);
        }
        this.panelService.toggle();
      }).catch(console.error);
  }

  private loanDetails(quoteId: any) {
    this.quoteStoreService.getQuoteDetailsById(quoteId).subscribe((quoteDetails: any) => {
      if (quoteDetails) {
        this.quoteStoreService.setQuoteWorkbook(quoteDetails);
        this.global_utility.navigateToURL(['accountHistory/loandetails']);
      }
    });
  }
}
